import React from "react";
import { observer } from "mobx-react";
import type { WalletStore } from "../../stores/wallet/wallet-store";
import { Button } from "../../../../components/inputs/button/button";
import FontBody3 from "../../../../components/fonts/font-body3/font-body3";
import { FONT_COLOR, FONT_VARIANT } from "../../../../components/fonts/font-props";
import FontHeading2 from "../../../../components/fonts/font-heading2/font-heading2";
import Currency from "../../../../components/currency/currency";
import { BUTTON_VARIANTS } from "../../../../components/inputs/button-variants";
import "./wallet-balance.scss";
import FontBody2 from "../../../../components/fonts/font-body2/font-body2";
import FontHeading5 from "../../../../components/fonts/font-heading5/font-heading5";
import useDashboardTranslation from "../../../../dashboard-translation/hooks/dashboard-translation-hook";

interface Props {
    walletStore: WalletStore;
    showAddCreditsButton?: boolean;
}

const WalletBalance: React.FC<Props> = observer(({walletStore, showAddCreditsButton = true} :Props) => {
    const scope = 'dashboard-billing';
    const {getTranslation} = useDashboardTranslation();
    const firstChargeBonusPromotion = walletStore.firstChargeBonusPromotion;

    return (
        <div className="wallet-balance">
            {firstChargeBonusPromotion && <div className="wallet-balance-special-offer-title">{getTranslation(firstChargeBonusPromotion.title, scope)}</div>}
            <div className="wallet-balance-top-text">
                <div><FontBody3 color={FONT_COLOR.NEUTRAL_1_WHITE}>Current Balance</FontBody3></div>
                <FontHeading2 color={FONT_COLOR.NEUTRAL_1_WHITE} variant={FONT_VARIANT.BOLD}>
                    <Currency amount={walletStore.amount} currencyCode={walletStore.walletCurrencyCode} useNative={true} />
                </FontHeading2>
                {
                    firstChargeBonusPromotion && (
                    <div className="wallet-balance-special-offer-description">
                        <FontHeading5 color={FONT_COLOR.NEUTRAL_1_WHITE} variant={FONT_VARIANT.BOLD}>{getTranslation(firstChargeBonusPromotion.description, scope)}</FontHeading5>
                    </div>
                )}
            </div>
            <div className="wallet-balance-bottom-container">
                {walletStore.lastRechargeDateFormatted !== null && (<FontBody2 color={FONT_COLOR.NEUTRAL_1_WHITE}>Last charge: {walletStore.lastRechargeDateFormatted}</FontBody2>)}
                <div className="wallet-balance-bottom-container-cta">
                    {!walletStore.hasPaymentMethod && <Button onClick={walletStore.addPaymentMethodHandler} variant={BUTTON_VARIANTS.PrimaryAccent} text="Set up now" />}
                    {showAddCreditsButton && <Button onClick={() => walletStore.setShouldShowAddCreditsModal(true)} variant={BUTTON_VARIANTS.PrimaryAccent} text="Add Credits" />}
                </div>
            </div>
        </div>
    )
});

export default WalletBalance;